import { Grid, GridItem, Nowrap, Section } from '@farmersdog/corgi-x';
import { getLinkToFreshSignup } from '@farmersdog/tosa/src/utils/getLinkToSignupFlow';
import {
  CtaTrackerV2,
  ReviewsRedesignSections,
} from 'src/pages/HomepageRedesign/components/CtaTrackerV2';
import { ExtendedButton } from 'src/pages/HomepageRedesign/components';

import { ExtendedText } from 'src/pages/HomepageRedesign/components/ExtendedText';
import { PATH_SIGNUP_ME } from '@farmersdog/constants/paths';
import { FiveStarsIcon } from './assets';
import { ImageMarqueeMobile } from './ImageMarqueeMobile';
import { ImageMarqueeDesktop } from './ImageMarqueeDesktop';

import { useTrackedSectionRef } from '../../../../hooks/useTrackedSections';
import { useReferrer } from 'src/hooks/useReferrer';

import styles from './ReviewsHero.module.css';
import { track } from 'src/analytics';

export const GOOGLE_REVIEWS_LINK = 'https://tfd.love/GoogleReviews';

export const ReviewsHero = () => {
  const { discountAmount } = useReferrer();

  const linkToFreshSignup = getLinkToFreshSignup(PATH_SIGNUP_ME);
  const sectionRef = useTrackedSectionRef(ReviewsRedesignSections.Hero);

  const handleGoogleReviewsClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    track('clicked', {
      component: 'button',
      type: 'select',
      moduleLevel: 1,
      moduleName: ReviewsRedesignSections.Hero,
      text: 'Google Reviews',
      destination: GOOGLE_REVIEWS_LINK,
    });

    setTimeout(() => {
      window.open(GOOGLE_REVIEWS_LINK, '_blank', 'noopener,noreferrer');
    }, 50);
  };

  return (
    <Section
      aria-labelledby="reviews-hero-heading"
      bottomSpacing="md"
      className={styles.root}
      widthConstraint="xl"
      sectionRef={sectionRef}
    >
      {/* Hidden on `lg` screens via CSS */}
      <ImageMarqueeMobile />

      <Grid>
        <GridItem xs={12} lg={5} className={styles.contentGridItem}>
          <div>
            <ExtendedText
              as="h1"
              variant="heading-32"
              color="Kale3"
              weight="black"
              className={styles.heading}
              id="reviews-hero-heading"
            >
              Billions of meals.
              <br />
              Millions of happy dogs.
            </ExtendedText>
            <ExtendedText
              as="h2"
              variant="heading-16"
              color="Kale3"
              bottomSpacing="md"
              className={styles.subheading}
            >
              Every day we get positive reviews and life changing stories from
              dogs of all ages, sizes, <Nowrap>and breeds.</Nowrap>
            </ExtendedText>
            <CtaTrackerV2
              type="select"
              moduleLevel={1}
              moduleName={ReviewsRedesignSections.Hero}
            >
              <ExtendedButton
                variant="solid-kale-2"
                type="link"
                to={linkToFreshSignup}
                className={styles.cta}
              >
                Start Fresh With {discountAmount}% Off
              </ExtendedButton>
            </CtaTrackerV2>
            <br />

            <div
              aria-label="View Google Reviews"
              role="link"
              onClick={handleGoogleReviewsClick}
              className={styles.googleReviewsLink}
            >
              <FiveStarsIcon aria-label="Five stars" />
              <ExtendedText
                color="Kale3"
                variant="heading-16"
                weight="bold"
                leftSpacing="sm"
                underline
              >
                Google Reviews
              </ExtendedText>
              <ExtendedText
                as="span"
                color="Kale3"
                variant="heading-16"
                weight="bold"
              >
                {' '}
                (4.8)
              </ExtendedText>
            </div>
          </div>
        </GridItem>

        <GridItem lg={7}>
          {/* Visible on `lg` screens via CSS */}
          <ImageMarqueeDesktop />
        </GridItem>
      </Grid>
    </Section>
  );
};
